 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import A0_FRONTCOVER from '@/components/00_frontcover'
 import A1_FM01 from '@/components/01_fm01'
 import A2_TITLE from '@/components/02_title'
 import A2I_COPY from '@/components/02i_copy'
 import A3_CONTENTS from '@/components/03_contents'
 import A4_PREFACE from '@/components/04_preface'
 import A5_CHAPTER01 from '@/components/05_chapter01'
 import A6_CHAPTER011 from '@/components/06_chapter011'
 import A7_CHAPTER012 from '@/components/07_chapter012'
 import A8_CHAPTER013 from '@/components/08_chapter013'
 import A9_CHAPTER014 from '@/components/09_chapter014'
 import A0_CHAPTER015 from '@/components/10_chapter015'
 import A1_CHAPTER016 from '@/components/11_chapter016'
 import A2_CHAPTER017 from '@/components/12_chapter017'
 import A3_CHAPTER018 from '@/components/13_chapter018'
 import A4_CHAPTER02 from '@/components/14_chapter02'
 import A5_CHAPTER021 from '@/components/15_chapter021'
 import A6_CHAPTER022 from '@/components/16_chapter022'
 import A7_CHAPTER023 from '@/components/17_chapter023'
 import A8_CHAPTER024 from '@/components/18_chapter024'
 import A9_CHAPTER025 from '@/components/19_chapter025'
 import A0_CHAPTER026 from '@/components/20_chapter026'
 import A1_CHAPTER027 from '@/components/21_chapter027'
 import A2_CHAPTER028 from '@/components/22_chapter028'
 import A3_CHAPTER03 from '@/components/23_chapter03'
 import A4_CHAPTER031 from '@/components/24_chapter031'
 import A5_CHAPTER032 from '@/components/25_chapter032'
 import A6_CHAPTER033 from '@/components/26_chapter033'
 import A7_CHAPTER034 from '@/components/27_chapter034'
 import A8_CHAPTER035 from '@/components/28_chapter035'
 import A9_CHAPTER036 from '@/components/29_chapter036'
 import A0_CHAPTER037 from '@/components/30_chapter037'
 import A1_CHAPTER038 from '@/components/31_chapter038'
 import A2_CHAPTER04 from '@/components/32_chapter04'
 import A3_CHAPTER041 from '@/components/33_chapter041'
 import A4_CHAPTER042 from '@/components/34_chapter042'
 import A5_CHAPTER043 from '@/components/35_chapter043'
 import A6_CHAPTER044 from '@/components/36_chapter044'
 import A7_CHAPTER045 from '@/components/37_chapter045'
 import A8_CHAPTER046 from '@/components/38_chapter046'
 import A9_CHAPTER047 from '@/components/39_chapter047'
 import A0_CHAPTER048 from '@/components/40_chapter048'
 import A1_CHAPTER05 from '@/components/41_chapter05'
 import A2_CHAPTER051 from '@/components/42_chapter051'
 import A3_CHAPTER052 from '@/components/43_chapter052'
 import A4_CHAPTER053 from '@/components/44_chapter053'
 import A5_CHAPTER054 from '@/components/45_chapter054'
 import A6_CHAPTER055 from '@/components/46_chapter055'
 import A7_CHAPTER056 from '@/components/47_chapter056'
 import A8_CHAPTER057 from '@/components/48_chapter057'
 import A9_CHAPTER06 from '@/components/49_chapter06'
 import A0_CHAPTER061 from '@/components/50_chapter061'
 import A1_CHAPTER062 from '@/components/51_chapter062'
 import A2_CHAPTER063 from '@/components/52_chapter063'
 import A3_CHAPTER064 from '@/components/53_chapter064'
 import A4_CHAPTER065 from '@/components/54_chapter065'
 import A5_CHAPTER066 from '@/components/55_chapter066'
 import A6_CHAPTER067 from '@/components/56_chapter067'
 import A7_CHAPTER068 from '@/components/57_chapter068'
 import A8_CHAPTER07 from '@/components/58_chapter07'
 import A9_CHAPTER071 from '@/components/59_chapter071'
 import A0_CHAPTER072 from '@/components/60_chapter072'
 import A1_CHAPTER073 from '@/components/61_chapter073'
 import A2_CHAPTER074 from '@/components/62_chapter074'
 import A3_CHAPTER075 from '@/components/63_chapter075'
 import A4_CHAPTER076 from '@/components/64_chapter076'
 import A5_CHAPTER077 from '@/components/65_chapter077'
 import A6_CHAPTER078 from '@/components/66_chapter078'
 import A7_CHAPTER08 from '@/components/67_chapter08'
 import A8_CHAPTER081 from '@/components/68_chapter081'
 import A9_CHAPTER082 from '@/components/69_chapter082'
 import A0_CHAPTER083 from '@/components/70_chapter083'
 import A1_CHAPTER084 from '@/components/71_chapter084'
 import A2_CHAPTER085 from '@/components/72_chapter085'
 import A3_CHAPTER086 from '@/components/73_chapter086'
 import A4_CHAPTER087 from '@/components/74_chapter087'
 import A5_CHAPTER088 from '@/components/75_chapter088'
 import A6_CHAPTER09 from '@/components/76_chapter09'
 import A7_CHAPTER091 from '@/components/77_chapter091'
 import A8_CHAPTER092 from '@/components/78_chapter092'
 import A9_CHAPTER093 from '@/components/79_chapter093'
 import A0_CHAPTER094 from '@/components/80_chapter094'
 import A1_CHAPTER095 from '@/components/81_chapter095'
 import A2_CHAPTER096 from '@/components/82_chapter096'
 import A3_CHAPTER097 from '@/components/83_chapter097'
 import A4_CHAPTER10 from '@/components/84_chapter10'
 import A5_CHAPTER101 from '@/components/85_chapter101'
 import A6_CHAPTER102 from '@/components/86_chapter102'
 import A7_CHAPTER103 from '@/components/87_chapter103'
 import A8_CHAPTER104 from '@/components/88_chapter104'
 import A9_CHAPTER105 from '@/components/89_chapter105'
 import A0_CHAPTER106 from '@/components/90_chapter106'
 import A1_CHAPTER107 from '@/components/91_chapter107'
 import A2_CHAPTER108 from '@/components/92_chapter108'
 import A3_CHAPTER11 from '@/components/93_chapter11'
 import A4_CHAPTER111 from '@/components/94_chapter111'
 import A5_CHAPTER112 from '@/components/95_chapter112'
 import A6_CHAPTER113 from '@/components/96_chapter113'
 import A7_CHAPTER114 from '@/components/97_chapter114'
 import A8_CHAPTER115 from '@/components/98_chapter115'
 import A9_CHAPTER116 from '@/components/99_chapter116'
 import A00_CHAPTER117 from '@/components/100_chapter117'
 import A01_CHAPTER118 from '@/components/101_chapter118'
 import A02_CHAPTER12 from '@/components/102_chapter12'
 import A03_CHAPTER121 from '@/components/103_chapter121'
 import A04_CHAPTER122 from '@/components/104_chapter122'
 import A05_CHAPTER123 from '@/components/105_chapter123'
 import A06_CHAPTER124 from '@/components/106_chapter124'
 import A07_CHAPTER125 from '@/components/107_chapter125'
 import A08_CHAPTER126 from '@/components/108_chapter126'
 import A09_CHAPTER127 from '@/components/109_chapter127'
 import A10_CHAPTER128 from '@/components/110_chapter128'
 import A11_CHAPTER13 from '@/components/111_chapter13'
 import A12_CHAPTER131 from '@/components/112_chapter131'
 import A13_CHAPTER132 from '@/components/113_chapter132'
 import A14_CHAPTER133 from '@/components/114_chapter133'
 import A15_CHAPTER134 from '@/components/115_chapter134'
 import A16_CHAPTER135 from '@/components/116_chapter135'
 import A17_CHAPTER136 from '@/components/117_chapter136'
 import A18_CHAPTER137 from '@/components/118_chapter137'
 import A19_CHAPTER138 from '@/components/119_chapter138'
 import A20_CHAPTER14 from '@/components/120_chapter14'
 import A21_CHAPTER141 from '@/components/121_chapter141'
 import A22_CHAPTER142 from '@/components/122_chapter142'
 import A23_CHAPTER143 from '@/components/123_chapter143'
 import A24_CHAPTER144 from '@/components/124_chapter144'
 import A25_CHAPTER145 from '@/components/125_chapter145'
 import A26_CHAPTER146 from '@/components/126_chapter146'
 import A27_CHAPTER147 from '@/components/127_chapter147'
 import A28_CHAPTER148 from '@/components/128_chapter148'
 import A29_CHAPTER15 from '@/components/129_chapter15'
 import A30_CHAPTER151 from '@/components/130_chapter151'
 import A31_CHAPTER152 from '@/components/131_chapter152'
 import A32_CHAPTER153 from '@/components/132_chapter153'
 import A33_CHAPTER154 from '@/components/133_chapter154'
 import A34_CHAPTER155 from '@/components/134_chapter155'
 import A35_CHAPTER156 from '@/components/135_chapter156'
 import A36_CHAPTER157 from '@/components/136_chapter157'
 import A37_CHAPTER158 from '@/components/137_chapter158'
 import A38_CHAPTER16 from '@/components/138_chapter16'
 import A39_CHAPTER161 from '@/components/139_chapter161'
 import A40_CHAPTER162 from '@/components/140_chapter162'
 import A41_CHAPTER163 from '@/components/141_chapter163'
 import A42_CHAPTER164 from '@/components/142_chapter164'
 import A43_CHAPTER165 from '@/components/143_chapter165'
 import A44_CHAPTER166 from '@/components/144_chapter166'
 import A45_CHAPTER167 from '@/components/145_chapter167'
 import A46_CHAPTER168 from '@/components/146_chapter168'
 import A47_CHAPTER17 from '@/components/147_chapter17'
 import A48_CHAPTER171 from '@/components/148_chapter171'
 import A49_CHAPTER172 from '@/components/149_chapter172'
 import A50_CHAPTER173 from '@/components/150_chapter173'
 import A51_CHAPTER174 from '@/components/151_chapter174'
 import A52_CHAPTER175 from '@/components/152_chapter175'
 import A53_CHAPTER176 from '@/components/153_chapter176'
 import A54_CHAPTER177 from '@/components/154_chapter177'
 import A55_CHAPTER178 from '@/components/155_chapter178'
 import A56_CHAPTER18 from '@/components/156_chapter18'
 import A57_CHAPTER181 from '@/components/157_chapter181'
 import A58_CHAPTER182 from '@/components/158_chapter182'
 import A59_CHAPTER183 from '@/components/159_chapter183'
 import A60_CHAPTER184 from '@/components/160_chapter184'
 import A61_CHAPTER185 from '@/components/161_chapter185'
 import A62_CHAPTER186 from '@/components/162_chapter186'
 import A63_CHAPTER187 from '@/components/163_chapter187'
 import A64_CHAPTER188 from '@/components/164_chapter188'
 import A65_CHAPTER19 from '@/components/165_chapter19'
 import A66_CHAPTER191 from '@/components/166_chapter191'
 import A67_CHAPTER192 from '@/components/167_chapter192'
 import A68_CHAPTER193 from '@/components/168_chapter193'
 import A69_CHAPTER194 from '@/components/169_chapter194'
 import A70_CHAPTER195 from '@/components/170_chapter195'
 import A71_CHAPTER196 from '@/components/171_chapter196'
 import A72_CHAPTER197 from '@/components/172_chapter197'
 import A73_CHAPTER20 from '@/components/173_chapter20'
 import A74_CHAPTER201 from '@/components/174_chapter201'
 import A75_CHAPTER202 from '@/components/175_chapter202'
 import A76_CHAPTER203 from '@/components/176_chapter203'
 import A77_CHAPTER204 from '@/components/177_chapter204'
 import A78_CHAPTER205 from '@/components/178_chapter205'
 import A79_CHAPTER206 from '@/components/179_chapter206'
 import A80_CHAPTER207 from '@/components/180_chapter207'
 import A81_CHAPTER208 from '@/components/181_chapter208'
 import A82_CHAPTER209 from '@/components/182_chapter209'
 import A83_CHAPTER2010 from '@/components/183_chapter2010'
 import A84_CHAPTER2011 from '@/components/184_chapter2011'
 import A85_CHAPTER2012 from '@/components/185_chapter2012'
 import A86_CHAPTER2013 from '@/components/186_chapter2013'
 import A87_CHAPTER2014 from '@/components/187_chapter2014'
 import A88_NOTES from '@/components/188_notes'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/03_contents",
 			"name" : "03_contents",
 			"component" : A3_CONTENTS
 		},
 		{
 			"path" : "/04_preface",
 			"name" : "04_preface",
 			"component" : A4_PREFACE
 		},
 		{
 			"path" : "/05_chapter01",
 			"name" : "05_chapter01",
 			"component" : A5_CHAPTER01
 		},
 		{
 			"path" : "/06_chapter011",
 			"name" : "06_chapter011",
 			"component" : A6_CHAPTER011
 		},
 		{
 			"path" : "/07_chapter012",
 			"name" : "07_chapter012",
 			"component" : A7_CHAPTER012
 		},
 		{
 			"path" : "/08_chapter013",
 			"name" : "08_chapter013",
 			"component" : A8_CHAPTER013
 		},
 		{
 			"path" : "/09_chapter014",
 			"name" : "09_chapter014",
 			"component" : A9_CHAPTER014
 		},
 		{
 			"path" : "/10_chapter015",
 			"name" : "10_chapter015",
 			"component" : A0_CHAPTER015
 		},
 		{
 			"path" : "/11_chapter016",
 			"name" : "11_chapter016",
 			"component" : A1_CHAPTER016
 		},
 		{
 			"path" : "/12_chapter017",
 			"name" : "12_chapter017",
 			"component" : A2_CHAPTER017
 		},
 		{
 			"path" : "/13_chapter018",
 			"name" : "13_chapter018",
 			"component" : A3_CHAPTER018
 		},
 		{
 			"path" : "/14_chapter02",
 			"name" : "14_chapter02",
 			"component" : A4_CHAPTER02
 		},
 		{
 			"path" : "/15_chapter021",
 			"name" : "15_chapter021",
 			"component" : A5_CHAPTER021
 		},
 		{
 			"path" : "/16_chapter022",
 			"name" : "16_chapter022",
 			"component" : A6_CHAPTER022
 		},
 		{
 			"path" : "/17_chapter023",
 			"name" : "17_chapter023",
 			"component" : A7_CHAPTER023
 		},
 		{
 			"path" : "/18_chapter024",
 			"name" : "18_chapter024",
 			"component" : A8_CHAPTER024
 		},
 		{
 			"path" : "/19_chapter025",
 			"name" : "19_chapter025",
 			"component" : A9_CHAPTER025
 		},
 		{
 			"path" : "/20_chapter026",
 			"name" : "20_chapter026",
 			"component" : A0_CHAPTER026
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js